<div style="text-align:center;padding-top:10px" *ngIf="healthRestrictions.length == 0" translate>
    No Health Restriction data exists for student
</div>
<div *ngIf="healthRestrictions.length > 0 ">
    <div class="flex-content">
        <mat-table style="width: 100%;" #table [dataSource]="tylerMatData" multiTemplateDataRows matSort
            matSortDisableClear matSortActive="Comment" id="healthRestrictionTable"
            aria-label="Student Health Restriction Table" tabindex="0">           

            <!-- Start Date -->
            <ng-container matColumnDef="DateRestrictionStart">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Start</span>
                    <filter [data]="tylerMatData" columnName="DateRestrictionStart" dataType="date" id="startdateFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let hr">
                    {{hr.DateRestrictionStart | date:'MM/dd/yy'}}
                </mat-cell>
            </ng-container>

            <!-- End Date -->
            <ng-container matColumnDef="DateRestrictionEnd">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>End</span>
                    <filter [data]="tylerMatData" columnName="DateRestrictionEnd" dataType="date" id="enddateFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let hr">
                    {{hr.DateRestrictionEnd | date:'MM/dd/yy'}}
                </mat-cell>
            </ng-container>

            <!-- Period -->
            <ng-container matColumnDef="Period">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Period</span>
                    <filter [data]="tylerMatData" columnName="Period" dataType="string" id="periodFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let hr">
                    {{hr.Period}}
                </mat-cell>
            </ng-container>

            <!-- UnderCare -->
            <ng-container matColumnDef="UnderCare">
                <mat-header-cell *matHeaderCellDef style="display: flex; justify-content: center;" mat-sort-header>
                    <span translate>Under practitioner's care</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let hr" style="display: flex; justify-content: center;">
                    <span *ngIf="hr.UnderDoctorsCare">Y</span> 
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columnDisplay; sticky: true" id="healthRestrictionHeader">
            </mat-header-row>
            <!-- Data rows -->
            <mat-row *matRowDef="let row; columns: columnDisplay; let i = index;" id="healthRestrictionDataRow{{i}}"
                tabindex="0" matRipple>
            </mat-row>
        </mat-table>
    </div>
</div>